module.exports = __webpack_public_path__ + "img/SecondaryAttendance.927fe018.png";